<mat-card appearance="outlined" class="new-theme-typography login-form">
    <mat-card-header class="justify-center">
        <div class="flex">
            <img src="assets/images/logo - dark.svg" style="height: 24px">
            <h3 class="pl-4">Partner Portal</h3>
        </div>
    </mat-card-header>
    <mat-card-content>
        <div class="lendio-mat-card-divider"></div>
        <form [formGroup]="loginForm" (ngSubmit)="login()">
            <p>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Email address</mat-label>
                    <input formControlName="email"
                        required
                        data-cy="login-email"
                        name="email"
                        id="login-email"
                        matInput
                        placeholder="Ex. email@domain.com"
                        email
                        type="email">
                    <mat-icon matPrefix fontSet="material-icons-outlined">mail</mat-icon>
                </mat-form-field>
            </p>
            <div class="lendio-mat-card-divider"></div>
            <p>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Password</mat-label>
                    <input formControlName="password"
                        required
                        data-cy="login-password"
                        name="password"
                        id="login-password"
                        matInput
                        type="{{ showPassword ? 'text' : 'password' }}">
                    <mat-icon matPrefix fontSet="material-icons-outlined">lock</mat-icon>
                    <mat-icon matSuffix (click)="showPassword = !showPassword" class="cursor-pointer">{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </mat-form-field>
            </p>
            <div class="lendio-mat-card-divider"></div>
            <p>
                <button data-cy="login-button" id="login-button" mat-flat-button color="primary" [disabled]="!canSubmit()" class="w-full">
                    <span *ngIf="loading else text" class="spinner">&nbsp;</span>
                    <ng-template #text>Sign in</ng-template>
                </button>
            </p>
        </form>
    </mat-card-content>
    <mat-card-footer class="text-center font-normal">
        <a class="text-blue-400" href="javascript:;" (click)="forgotPasswordDialog()" data-cy="forgot-password">Forgot Password</a>
    </mat-card-footer>
</mat-card>
